export default "<p>\n  geom works!\n</p>\n"